import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const REVIEWS = [
  {
    text: 'Keyless Vending made the whole process effortless. They showed up, installed everything, and we haven\'t had to worry about it since.',
    name: 'Marcus T.',
    role: 'Office Manager',
    location: 'San Antonio',
  },
  {
    text: 'Our residents love the machine. Whenever there\'s been an issue, they\'re on it same day. Super professional team.',
    name: 'Diana R.',
    role: 'Property Manager',
    location: 'North SA',
  },
  {
    text: 'We got a smart cooler placed in our gym and it\'s been a huge hit. Looks great and it\'s always stocked.',
    name: 'Carlos M.',
    role: 'Gym Owner',
    location: 'Stone Oak',
  },
  {
    text: 'Honestly didn\'t expect it to be this easy. No cost, no hassle, the machine just showed up and works perfectly.',
    name: 'Priya K.',
    role: 'HR Director',
    location: 'Medical Center Area',
  },
  {
    text: 'Great local business. Love that they\'re from San Antonio and actually show up when they say they will.',
    name: 'James L.',
    role: 'Facilities Coordinator',
    location: 'Downtown SA',
  },
];

const Stars = () => (
  <div className="flex gap-0.5 mb-4">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-kv-gold text-kv-gold" />
    ))}
  </div>
);

const sectionVariants = {
  hidden: { opacity: 0, y: 18 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
};

export const Reviews = () => {
  return (
    <section id="reviews" className="scroll-mt-24 bg-white py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <motion.div
          variants={sectionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.25 }}
          className="text-center mb-12 sm:mb-16"
        >
          <div className="flex items-center justify-center gap-2 mb-4">
            <Star className="h-4 w-4 fill-kv-gold text-kv-gold" />
            <span className="text-xs uppercase tracking-[0.22em] text-kv-gold font-sans font-semibold">
              Customer Reviews
            </span>
            <Star className="h-4 w-4 fill-kv-gold text-kv-gold" />
          </div>
          <h2 className="text-3xl sm:text-4xl font-display tracking-tight text-kv-black-2">
            What San Antonio is saying.
          </h2>
        </motion.div>

        {/* Reviews Grid — first 3 */}
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6"
        >
          {REVIEWS.slice(0, 3).map((review) => (
            <motion.div
              key={review.name}
              variants={cardVariants}
              className="rounded-2xl border border-black/8 bg-white p-6 sm:p-8 shadow-[0_1px_0_rgba(17,17,20,0.04),0_10px_30px_rgba(17,17,20,0.05)] hover:-translate-y-0.5 transition-transform flex flex-col"
            >
              <Stars />
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed font-sans mb-6 flex-1">
                "{review.text}"
              </p>
              <div className="border-t border-black/6 pt-4">
                <p className="text-sm font-semibold text-kv-black-2 font-sans">{review.name}</p>
                <p className="text-xs text-gray-400 font-sans">
                  {review.role}, {review.location}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Reviews Grid — last 2, centered */}
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto"
        >
          {REVIEWS.slice(3).map((review) => (
            <motion.div
              key={review.name}
              variants={cardVariants}
              className="rounded-2xl border border-black/8 bg-white p-6 sm:p-8 shadow-[0_1px_0_rgba(17,17,20,0.04),0_10px_30px_rgba(17,17,20,0.05)] hover:-translate-y-0.5 transition-transform flex flex-col"
            >
              <Stars />
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed font-sans mb-6 flex-1">
                "{review.text}"
              </p>
              <div className="border-t border-black/6 pt-4">
                <p className="text-sm font-semibold text-kv-black-2 font-sans">{review.name}</p>
                <p className="text-xs text-gray-400 font-sans">
                  {review.role}, {review.location}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
